import { AleloButton, AleloLayout } from '@/components/AleloLayout'
import styles from '@/components/AleloLayout.module.css'
import { RangoAlert, RangoFlag } from '@/components/rango'

type Props = {
  tone: 'positive' | 'negative'
  title: string
  message: string
  /** Próximo passo; sem ele, `hint` diz ao usuário o que fazer. */
  action?: { label: string; onClick: () => void }
  hint?: string
}

/**
 * Resultado da redefinição de senha: o sucesso da S8 e as telas
 * `reset-password-success` / `reset-password-error` do Auth0 usam o mesmo
 * card — título, mensagem e uma única ação.
 */
export function ResetPasswordOutcome({ tone, title, message, action, hint }: Props) {
  return (
    <AleloLayout>
      <h1 className={styles.title}>{title}</h1>
      {tone === 'positive' ? (
        <RangoFlag tone="positive">{message}</RangoFlag>
      ) : (
        <RangoAlert tone="negative">{message}</RangoAlert>
      )}
      {action ? (
        <div
          className={styles.actions}
          style={{ marginTop: 'var(--rango-spacing-4x)' }}
        >
          <AleloButton onClick={action.onClick}>{action.label}</AleloButton>
        </div>
      ) : hint ? (
        <p className={styles.subtitle} style={{ marginTop: 'var(--rango-spacing-3x)' }}>
          {hint}
        </p>
      ) : null}
    </AleloLayout>
  )
}
